
// import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import { auth, idle, signalr, custom } from '@/service';
import DefaultAside from '../../containers/DefaultAside'
import DefaultHeaderDropdownAccnt from '../../containers/DefaultHeaderDropdownAccnt'
import _ from 'lodash'
import config from '@/config'
import Language from './language'

//i18n
import { SetLang } from '@/service/i18n'

// let check_permit = vs => _.filter(vs, v => {
//   if(!auth.has_level(v.level)) { return undefined; }
//   if(_.isArray(v.children)) { v.children = check_permit(v.children); }
//   return v;
// });

export default {
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    Language
  },
  // data: () => ({ nav: check_permit(links), pause: false, stale: undefined, stale_check : undefined }),
  data: () => {
    return {
      dashboard : '',
      custom : custom.custom_default,
      // all_nav : all_nav,
      auth : undefined,
      // nav: all_nav,
      base_href : `${location.protocol}//${location.host}`,
      b : undefined,
      pause: false,
      // location : 'wmds',
      service : '',
      stale: undefined,
      stale_check : undefined,
      profile: [],
      alert: false,
    }
  },
  computed: {
    is_custom() {
      return this.custom.slogan && this.custom.slogan.toUpperCase().indexOf('F1-UWSS') < 0
    },
    // manual() {
      // return window.open(`https://${location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${config.manual}`) 
    // },
    name() { return this.$route.name },
    list() { return this.$route.matched },
    nav() { return _.filter(all_nav, r => {
      if(_.indexOf(r.permission, auth.profile.permissions) == -1) { return undefined }
      r.children = r.children ? _.filter(r.children, s => _.indexOf(s.permission, auth.profile.permissions) > -1 ) : undefined
      return r
    })}
  },
  methods: {
    redir($event, rs) { console.log("redir", $event, rs) },
    toggle() { this.pause = !this.pause; this.pause ? idle.pause() : idle.resume(); },
    logout() { auth.logout(); this.$router.push('/auth/login') },
    location() { return location.hash.split('/')[1] },

    // 경로 이동시 sidebar 활성화 유무
    refresh_active(redirect) {
      Array.from( document.getElementsByClassName( 'nav-item' ) ).forEach( e => {
        // console.log(this.$route, redirect, e.dataset.name, redirect.endsWith(e.dataset.name), redirect.endsWith(this.$route.name))
        
        if(!e.dataset.name || this.$route.path == redirect) {
          return e.className = 'nav-item'
        }

        e.className = redirect.startsWith(e.dataset.name) ? 'nav-item active' : 'nav-item'

        if(!e.className.endsWith('active'))  { return }

        this.$router.push(redirect)
      } );
    },
    //sidebar toggle 활성화 유무
    toggle_active : function() {
      let g = !1;
      let v = 0;

      console.log(v)

      let wrapper = $('.wrapper');

      if(!g){
        let k = $('button.toggle-sidebar')

        wrapper.hasClass("sidebar_minimize") && (v = 1, k.addClass("toggled"), k.html('<i class="icon-options-vertical"></i>')),
        k.on("click", function() {
          1 == v ? (wrapper.removeClass("sidebar_minimize"), k.removeClass("toggled"), k.html('<i class="icon-menu"></i>'), v = 0) : (wrapper.addClass("sidebar_minimize"), k.addClass("toggled"), k.html('<i class="icon-options-vertical"></i>'), v = 1), $(window).resize()
        }), g = !0
      }

      $(".sidebar").hover(function() {
        wrapper.hasClass("sidebar_minimize") && wrapper.addClass("sidebar_minimize_hover")
      }, function() {
        wrapper.hasClass("sidebar_minimize") && wrapper.removeClass("sidebar_minimize_hover")
      })
    },

    //축소시 활성화 유무
    toggle_mini : function() {
      let c = !1;
      let d = !1;
      let h = 0;
      let u = 0;

      let html = $("html");

      if (!c) {
        let s = $(".sidenav-toggler")
        s.unbind('click').on("click", function() {
          // h == 1 ? ($("html").removeClass("nav_open"), s.removeClass("toggled"), h = 0) : ($("html").addClass("nav_open"), s.addClass("toggled"), h = 1)
          if(html.hasClass("nav_open")){
            html.removeClass("nav_open"), s.removeClass("toggled")
          }else{
            html.addClass("nav_open"), s.addClass("toggled")
          }
        }), c = !0
      }

      if (!d) {
        var w = $(".topbar-toggler");

        w.unbind('click').on("click", function() {
            // 1 == u ? ($("html").removeClass("topbar_open"), w.removeClass("toggled"), u = 0) : ($("html").addClass("topbar_open"), w.addClass("toggled"), u = 1)
          if(html.hasClass("topbar_open")){
            html.removeClass("topbar_open"), w.removeClass("toggled")
          }else{
            html.addClass("topbar_open"), w.addClass("toggled")
          }
        }), d = !0
    }
    },
    manual(){
      let lang = SetLang(localStorage['UWSS_MANAGER_LANG'] || 'EN');

      if(this.i18n == "EN" || lang == "EN"){
        return this.alert = true;
        // return window.open(`https://${location.hostname == 'localhost' ? 'api.f1secaas.net' : location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${config.manual}`)
      }
      
      if(this.i18n == "KO" || lang == "KO"){
        let manual = config.manual

        manual = manual.replace('en', 'ko')

        console.log(manual)

        return window.open(`https://${location.hostname == 'localhost' ? 'api.f1secaas.net' : location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${manual}`)
      }
    },
  },
  created: function() {
    this.dashboard = auth.profile && auth.profile.permissions && !auth.profile.permissions.startsWith('sales') ? 'dashboard' : 'dashboard_sales'
    this.custom = custom.setting()
    console.log(auth.profile)
    console.log('[vue] private container', 'created');
    console.log(custom.image, "custom.image")

    this.profile = auth.profile

    idle.start(this.logout, 15).keepalive(auth.refresh, 300);
    signalr.start('ws')
      .on('msg', m => this.$toastr.s(m.body ? m.body : m, 'Message'))
      .on('emsg', m => this.$toastr.w(m.body ? m.body : m, 'Message'))
      .on('err', m => console.error(m))
      .on('error', m => console.error(m))
      .on('logout', m => { this.$toastr.s(m.body ? m.body : m, 'Message'); this.logout(); })
      // 매니저는 사용하지 않음
      // .on('wmds', m => signalr.publish('wmds', m))
      // .on('wsfinder', m => signalr.publish('wsfinder', m))
      .on('webcastle', m => signalr.publish('webcastle', m));
    this.stale_check = setInterval(() => {
      if(idle.p) { return this.stale = '∞'; }
      let ts = parseInt((idle.stale - new Date().getTime()) / 1000);
      if(ts > 300) { return this.stale = '+5:00'; } // 5분 이내는 신경쓰지 않음.
      let m = (parseInt(ts / 60)).toString();
      let s = (parseInt(ts % 60) + 100).toString().substr(1,2);
      return this.stale = `${m}:${s}`;
    }, 1000);
  },
  destroyed: function() {
    console.log('[vue] private container i18n', 'destroyed');
    signalr.stop();
    idle.stop();
    clearInterval(this.stale_check);
  },
  mounted: function() { 
    console.log('[vue] private container i18n', 'mounted');

    const plugin = document.createElement("script");
    plugin.setAttribute("public","/f1/assets/js/atlantis.min.js");
    plugin.async = true
    document.head.appendChild(plugin)
  },
}